/*
 * Catch-all route for all unmatched paths.
 * This ensures that React Navigation can handle client-side routing
 * for routes like /sales-portal/order-entry/:supplierUUID/:restaurantUUID
 * without Next.js returning a 404.
 *
 * This page simply re-exports the default export from ./index.page.tsx
 * to avoid code duplication.
 */

export { default } from './index.page';
